(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veras-application"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-vp-application]');
    if (!root) return;
    const form = root.querySelector('#RentalApplicationForm');
    if (!form) return;
    const steps = Array.from(form.querySelectorAll('[data-step]'));
    const markers = Array.from(root.querySelectorAll('[data-step-marker]'));
    const storageKey = 'veras-rental-application';

    const showStep = (number) => {
      steps.forEach((step) => {
        const active = Number(step.dataset.step) === number;
        step.hidden = !active;
        step.classList.toggle('is-active', active);
      });
      markers.forEach((marker) => marker.classList.toggle('is-active', Number(marker.dataset.stepMarker) <= number));
      const activeLegend = form.querySelector(`[data-step="${number}"] legend`);
      if (activeLegend) activeLegend.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    const save = () => {
      const values = {};
      form.querySelectorAll('input:not([type="hidden"]), select, textarea').forEach((field) => {
        if (!field.name) return;
        values[field.name] = field.type === 'checkbox' ? field.checked : field.value;
      });
      try { localStorage.setItem(storageKey, JSON.stringify(values)); } catch (error) {}
    };

    try {
      const saved = JSON.parse(localStorage.getItem(storageKey) || '{}');
      Object.entries(saved).forEach(([name, value]) => {
        const field = form.elements.namedItem(name);
        if (!field || name === 'contact[email]' || name === 'contact[Full name]') return;
        if (field.type === 'checkbox') field.checked = Boolean(value);
        else field.value = value;
      });
    } catch (error) {}

    const propertyHandle = new URLSearchParams(window.location.search).get('property');
    if (propertyHandle) {
      const option = form.querySelector(`[data-property-handle="${CSS.escape(propertyHandle)}"]`);
      if (option) option.selected = true;
    }

    form.addEventListener('input', save);
    const next = form.querySelector('[data-next-step]');
    if (next) next.addEventListener('click', () => {
      const firstStepFields = Array.from(steps[0].querySelectorAll('input, select, textarea'));
      const valid = firstStepFields.every((field) => field.reportValidity());
      if (valid) showStep(2);
    });
    const previous = form.querySelector('[data-previous-step]');
    if (previous) previous.addEventListener('click', () => showStep(1));
    form.addEventListener('submit', () => localStorage.removeItem(storageKey));
    if (root.querySelector('[data-application-success]')) localStorage.removeItem(storageKey);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veras-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vp-home]').forEach((root) => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const reveals = [...root.querySelectorAll('[data-vp-reveal]')];
    if (!reducedMotion.matches && 'IntersectionObserver' in window) {
      root.classList.add('vp-motion-ready');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      reveals.forEach((element) => observer.observe(element));
    } else {
      reveals.forEach((element) => element.classList.add('is-visible'));
    }

    const reel = root.querySelector('[data-vp-hero-reel]');
    if (reel) {
      const slides = [...reel.querySelectorAll('[data-vp-reel-slide]')];
      const dotsRoot = reel.querySelector('[data-vp-reel-dots]');
      const previous = reel.querySelector('[data-vp-reel-prev]');
      const next = reel.querySelector('[data-vp-reel-next]');
      const interval = Number(reel.dataset.interval) || 6000;
      let active = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let timer;
      const dots = slides.map((slide, index) => {
        if (!dotsRoot) return null;
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', `${dotsRoot.dataset.label} ${index + 1}`);
        button.addEventListener('click', () => show(index, true));
        dotsRoot.append(button);
        return button;
      });
      const restartProgress = () => {
        reel.classList.remove('is-running');
        reel.style.setProperty('--vp-reel-duration', `${interval}ms`);
        void reel.offsetWidth;
        if (!reducedMotion.matches && reel.dataset.autoplay === 'true' && slides.length > 1) reel.classList.add('is-running');
      };
      const stop = () => {
        window.clearTimeout(timer);
        reel.classList.remove('is-running');
      };
      const schedule = () => {
        stop();
        if (reducedMotion.matches || reel.dataset.autoplay !== 'true' || slides.length < 2 || document.hidden) return;
        restartProgress();
        timer = window.setTimeout(() => show(active + 1), interval);
      };
      function show(index) {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const selected = slideIndex === active;
          slide.classList.toggle('is-active', selected);
          slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
          const link = slide.querySelector('a');
          if (link) link.tabIndex = selected ? 0 : -1;
          if (dots[slideIndex]) dots[slideIndex].setAttribute('aria-current', selected ? 'true' : 'false');
        });
        schedule();
      }
      previous?.addEventListener('click', () => show(active - 1));
      next?.addEventListener('click', () => show(active + 1));
      reel.addEventListener('pointerenter', stop);
      reel.addEventListener('pointerleave', schedule);
      reel.addEventListener('focusin', stop);
      reel.addEventListener('focusout', () => window.setTimeout(() => {
        if (!reel.contains(document.activeElement)) schedule();
      }, 0));
      document.addEventListener('visibilitychange', schedule);
      reducedMotion.addEventListener('change', schedule);
      show(active);
    }

    const cardTrack = root.querySelector('[data-vp-card-track]');
    const cardControls = root.querySelector('[data-vp-card-controls]');
    if (cardTrack && cardControls) {
      const previous = cardControls.querySelector('[data-vp-card-prev]');
      const next = cardControls.querySelector('[data-vp-card-next]');
      const step = () => (cardTrack.querySelector('.vp-property-card')?.getBoundingClientRect().width || 360) + 18;
      const update = () => {
        previous.disabled = cardTrack.scrollLeft < 8;
        next.disabled = cardTrack.scrollLeft + cardTrack.clientWidth >= cardTrack.scrollWidth - 8;
        cardControls.hidden = cardTrack.scrollWidth <= cardTrack.clientWidth + 8;
      };
      previous.addEventListener('click', () => cardTrack.scrollBy({ left: -step(), behavior: reducedMotion.matches ? 'auto' : 'smooth' }));
      next.addEventListener('click', () => cardTrack.scrollBy({ left: step(), behavior: reducedMotion.matches ? 'auto' : 'smooth' }));
      cardTrack.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    }

    const initNeighborhoodReel = (neighborhoodReel) => {
      if (neighborhoodReel.dataset.vpReady === 'true') return;
      neighborhoodReel.dataset.vpReady = 'true';
      const slides = [...neighborhoodReel.querySelectorAll('[data-vp-neighborhood-slide]')];
      const dotsRoot = neighborhoodReel.querySelector('[data-vp-neighborhood-dots]');
      const previous = neighborhoodReel.querySelector('[data-vp-neighborhood-prev]');
      const next = neighborhoodReel.querySelector('[data-vp-neighborhood-next]');
      const toggle = neighborhoodReel.querySelector('[data-vp-neighborhood-toggle]');
      const toggleIcon = neighborhoodReel.querySelector('[data-vp-neighborhood-toggle-icon]');
      const status = neighborhoodReel.querySelector('[data-vp-neighborhood-status]');
      const interval = Number(neighborhoodReel.dataset.interval) || 6500;
      let active = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let timer;
      let inView = false;
      let userPaused = false;
      let hoverPaused = false;
      let focusPaused = false;
      let touchX = 0;
      let touchY = 0;
      const dots = slides.map((slide, index) => {
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', status?.dataset.slideLabel || 'slide');
        slide.setAttribute('aria-label', `${index + 1} ${status?.dataset.ofLabel || 'of'} ${slides.length}`);
        if (!dotsRoot) return null;
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', `${dotsRoot.dataset.label} ${index + 1}`);
        button.addEventListener('click', () => show(index, true));
        dotsRoot.append(button);
        return button;
      });
      const stop = () => {
        window.clearTimeout(timer);
        neighborhoodReel.classList.remove('is-running');
      };
      const announce = () => {
        if (status) status.textContent = `${status.dataset.slideLabel} ${active + 1} ${status.dataset.ofLabel} ${slides.length}`;
      };
      const updateToggle = () => {
        if (!toggle) return;
        toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        toggle.setAttribute('aria-label', userPaused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
        if (toggleIcon) toggleIcon.textContent = userPaused ? '▶' : 'Ⅱ';
      };
      const schedule = () => {
        stop();
        if (!inView || userPaused || hoverPaused || focusPaused || reducedMotion.matches || neighborhoodReel.dataset.autoplay !== 'true' || slides.length < 2 || document.hidden) return;
        neighborhoodReel.style.setProperty('--vp-neighborhood-duration', `${interval}ms`);
        void neighborhoodReel.offsetWidth;
        neighborhoodReel.classList.add('is-running');
        timer = window.setTimeout(() => show(active + 1, false), interval);
      };
      function show(index, shouldAnnounce = false) {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const selected = slideIndex === active;
          slide.classList.toggle('is-active', selected);
          slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
          if (dots[slideIndex]) dots[slideIndex].setAttribute('aria-current', selected ? 'true' : 'false');
        });
        if (shouldAnnounce) announce();
        schedule();
      }
      previous?.addEventListener('click', () => show(active - 1, true));
      next?.addEventListener('click', () => show(active + 1, true));
      toggle?.addEventListener('click', () => {
        userPaused = !userPaused;
        updateToggle();
        if (status) status.textContent = userPaused ? toggle.dataset.pausedStatus : toggle.dataset.playingStatus;
        if (userPaused) stop(); else schedule();
      });
      neighborhoodReel.addEventListener('pointerenter', () => {
        hoverPaused = true;
        stop();
      });
      neighborhoodReel.addEventListener('pointerleave', () => {
        hoverPaused = false;
        schedule();
      });
      neighborhoodReel.addEventListener('focusin', () => {
        focusPaused = true;
        stop();
      });
      neighborhoodReel.addEventListener('focusout', () => window.setTimeout(() => {
        if (!neighborhoodReel.contains(document.activeElement)) {
          focusPaused = false;
          schedule();
        }
      }, 0));
      neighborhoodReel.addEventListener('touchstart', (event) => {
        touchX = event.changedTouches[0].clientX;
        touchY = event.changedTouches[0].clientY;
      }, { passive: true });
      neighborhoodReel.addEventListener('touchend', (event) => {
        const deltaX = event.changedTouches[0].clientX - touchX;
        const deltaY = event.changedTouches[0].clientY - touchY;
        if (Math.abs(deltaX) > 44 && Math.abs(deltaX) > Math.abs(deltaY)) show(active + (deltaX < 0 ? 1 : -1), true);
      }, { passive: true });
      if ('IntersectionObserver' in window) {
        const neighborhoodObserver = new IntersectionObserver((entries) => {
          inView = entries[0].isIntersecting;
          if (inView) schedule(); else stop();
        }, { threshold: 0.28 });
        neighborhoodObserver.observe(neighborhoodReel);
      } else {
        inView = true;
      }
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop(); else schedule();
      });
      reducedMotion.addEventListener('change', schedule);
      updateToggle();
      show(active, false);
    };

    root.querySelectorAll('[data-vp-neighborhood-reel]').forEach(initNeighborhoodReel);
    if (window.Shopify?.designMode && document.documentElement.dataset.vpNeighborhoodEditorReady !== 'true') {
      document.documentElement.dataset.vpNeighborhoodEditorReady = 'true';
      document.addEventListener('shopify:section:load', (event) => {
        const loadedRoot = event.target.matches?.('[data-vp-home]') ? event.target : event.target.querySelector?.('[data-vp-home]');
        loadedRoot?.querySelectorAll('[data-vp-neighborhood-reel]').forEach(initNeighborhoodReel);
      });
    }

    const visual = root.querySelector('[data-vp-visual]');
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    if (visual && finePointer.matches && !reducedMotion.matches) {
      visual.addEventListener('pointermove', (event) => {
        const bounds = visual.getBoundingClientRect();
        const x = ((event.clientX - bounds.left) / bounds.width - 0.5) * 3;
        const y = ((event.clientY - bounds.top) / bounds.height - 0.5) * -3;
        visual.style.setProperty('--vp-tilt-x', `${x}deg`);
        visual.style.setProperty('--vp-tilt-y', `${y}deg`);
      });
      visual.addEventListener('pointerleave', () => {
        visual.style.setProperty('--vp-tilt-x', '0deg');
        visual.style.setProperty('--vp-tilt-y', '0deg');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veras-listings"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vp-listings]').forEach((root) => {
    const filters = [...root.querySelectorAll('[data-filter]')];
    const cards = [...root.querySelectorAll('[data-card]')];
    const markers = [...root.querySelectorAll('[data-marker]')];
    const count = root.querySelector('[data-count]');
    const grid = root.querySelector('[data-grid]');
    const map = root.querySelector('[data-map]');
    const empty = root.querySelector('[data-filter-empty]');
    const matches = (item) => {
      const city = root.querySelector('[data-filter="city"]').value;
      const beds = Number(root.querySelector('[data-filter="beds"]').value || 0);
      const baths = Number(root.querySelector('[data-filter="baths"]').value || 0);
      const price = Number(root.querySelector('[data-filter="price"]').value || 0);
      const section8 = root.querySelector('[data-filter="section8"]').checked;
      return (!city || item.dataset.city === city) && Number(item.dataset.beds) >= beds && Number(item.dataset.baths) >= baths && (!price || Number(item.dataset.price) <= price) && (!section8 || item.dataset.section8 === 'true');
    };
    const apply = () => {
      cards.forEach((item) => { item.hidden = !matches(item); });
      markers.forEach((item) => { item.hidden = !matches(item); });
      const total = cards.filter(matches).length;
      count.textContent = String(total);
      if (empty) empty.hidden = total > 0 || cards.length === 0;
    };
    const reset = () => {
      filters.forEach((filter) => {
        if (filter.type === 'checkbox') filter.checked = false;
        else filter.value = '';
      });
      apply();
    };
    filters.forEach((filter) => filter.addEventListener('change', apply));
    root.querySelector('[data-reset]').addEventListener('click', reset);
    const emptyReset = root.querySelector('[data-filter-empty-reset]');
    if (emptyReset) emptyReset.addEventListener('click', reset);
    root.querySelectorAll('[data-view]').forEach((button) => button.addEventListener('click', () => {
      root.querySelectorAll('[data-view]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      const showMap = button.dataset.view === 'map';
      grid.hidden = showMap;
      map.hidden = !showMap;
    }));
    apply();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veras-property"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vp-property]').forEach((root) => {
    const dialog = root.querySelector('[data-gallery-dialog]');
    if (!dialog) return;
    const slides = [...dialog.querySelectorAll('[data-gallery-slide]')];
    let trigger = null;
    root.querySelectorAll('[data-gallery-open]').forEach((button) => button.addEventListener('click', () => {
      trigger = button;
      const index = Number(button.dataset.galleryOpen || 0);
      dialog.showModal();
      requestAnimationFrame(() => slides[index]?.scrollIntoView({ block: 'nearest', inline: 'start' }));
    }));
    const close = () => {
      dialog.close();
      trigger?.focus();
    };
    dialog.querySelector('[data-gallery-close]')?.addEventListener('click', close);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veras-site-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.vp-menu').forEach((menu) => {
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => menu.removeAttribute('open')));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') menu.removeAttribute('open');
    });
  });
  document.querySelectorAll('[data-vp-header]').forEach((header) => {
    let queued = false;
    const update = () => {
      const scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      const progress = Math.min(1, Math.max(0, window.scrollY / scrollable));
      header.classList.toggle('is-scrolled', window.scrollY > 12);
      header.style.setProperty('--vp-page-progress', progress);
      queued = false;
    };
    window.addEventListener('scroll', () => {
      if (!queued) {
        queued = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });
    update();
  });

  } catch(e) { console.error(e); }
})();
})();
